import { AuthService } from "./auth.service";
import { Injectable, Output, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Meta, Title } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class EnumService {
  tkn: any;
  headers: any;
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private titleService: Title,
    private metaService: Meta
  ) {
    if (this.authService.isLogin()) {
      this.tkn = JSON.parse(sessionStorage.getItem("tk"));
      this.headers = new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.tkn.Token,
      });
    }
  }

  getEnumFilt(tipo, codigo) {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    let urlProductos = "";
    urlProductos =
      environment.apiUrlAdm + "/TEnum/Filt?tipo=" + tipo + "&codigo=" + codigo;
    return this.http.get(urlProductos, { headers: headers });
  }

  getEnum(tipo) {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    let urlProductos = "";
    urlProductos = environment.apiUrlAdm + "/TEnum/Tipo?tipo=" + tipo + "&len=1";
    return this.http.get(urlProductos, { headers: headers });
  }
  getMenu(tipoMenu) {
    let urlMenu = environment.apiUrl + "/MenusE/List?tipoMenuE=" + tipoMenu;
    return this.http.get(urlMenu);
  }
  getBannerINICIO() {
    // https://novaplaza.pe/apitest/Banner/List?TipoBanner=PRC
    let urlMenu = environment.apiUrl + "/inicioec";
    return this.http.get(urlMenu);
  }
  getBannerPRC() {
    // https://novaplaza.pe/apitest/Banner/List?TipoBanner=PRC
    let urlMenu = environment.apiUrl + "/Banner/List?TipoBanner=PRC";
    return this.http.get(urlMenu);
  }
  getBannerSLD() {
    // https://novaplaza.pe/apitest/Banner/List?TipoBanner=PRC
    let urlMenu = environment.apiUrl + "/Banner/List?TipoBanner=SLD";
    return this.http.get(urlMenu);
  }
  getBannerPUB() {
    // https://novaplaza.pe/apitest/Banner/List?TipoBanner=PRC
    let urlMenu = environment.apiUrl + "/Banner/List?TipoBanner=PUB";
    return this.http.get(urlMenu);
  }
  getBannerBPB() {
    let urlMenu = environment.apiUrl + "/Banner/List?TipoBanner=BPB";
    return this.http.get(urlMenu);
  }
  getBannerBPG4() {
    let urlMenu = environment.apiUrl + "/Banner/List?TipoBanner=BPG4";
    return this.http.get(urlMenu);
  }
  getBannerGamer() {
    let urlMenu = environment.apiUrl + "/Banner/List?TipoBanner=BG";
    return this.http.get(urlMenu);
  }
  getFilial() {
    let urlMenu = environment.apiUrlAdm + "/Filiales/List?filial=N%";
    return this.http.get(urlMenu, { headers: this.headers });
  }
  getCuentasBancosList(param) {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    let url = environment.apiUrlTeso + "/Cuentas_Bancos/List?CuentaB=" + param;
    return this.http.get(url, { headers: headers });
  }
  getAlmacenList(param) {
    this.tkn = JSON.parse(sessionStorage.getItem("tk"));
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tkn.Token,
    });
    let url = environment.apiUrlLogis + "/Almacenes/List?filial=" + param;
    return this.http.get(url, { headers: headers });
  }
  setTitleMeta(title,meta:any) {
    this.titleService.setTitle(title)
    this.metaService.updateTag(meta)
    sessionStorage.setItem("titleNav",title)
  }
}
